import {
  CLIENT_ID,
  BBAUTH_URL,
  DASHBOARD_URL,
} from "../../services/config";
import { RBACMenu } from "./auth.type";

export function transformQueryStringToObject<T>(queryString: string): T {
  const params = new URLSearchParams(queryString);
  const result: T = {} as T;

  const entries = Array.from(params.entries());

  for (let i = 0; i < entries.length; i += 1) {
    const [key, value] = entries[i];
    const nestedKeys = key.split(".");
    const lastKeyIndex = nestedKeys.length - 1;

    nestedKeys.reduce((obj: any, nestedKey: string, index: number) => {
      const newObj = obj;
      if (index === lastKeyIndex) {
        newObj[nestedKey] = value;
      } else {
        newObj[nestedKey] = newObj[nestedKey] || {};
      }
      return newObj;
    }, result);
  }

  return result;
}

export async function redirectToSSO(challenge: string) {
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    grant_type: "authorization_code",
    response_type: "code",
    redirect_uri: DASHBOARD_URL,
    code_challenge: challenge,
    code_challenge_method: "S256",
    scope: "openid",
  });

  try {
    window.location.replace(`${BBAUTH_URL}/auth?${params}`);
  } catch (err) {
    throw new Error("Error Redirect Login");
  }
}

export const logoutUser = async (idToken: string) => {
  const endsessionURL = `${BBAUTH_URL}/logout`;

  const endsessionParams = new URLSearchParams({
    id_token_hint: idToken,
    post_logout_redirect_uri: DASHBOARD_URL,
  });
  try {
    window.location.replace(`${endsessionURL}?${endsessionParams}`);
  } catch (err) {
    throw new Error("Error logging out");
  }
};

export default function getHasAccessAction({
  menus,
  menuTitle,
}: {
  menus: RBACMenu[];
  menuTitle: string;
}): boolean {
  if (menus.length === 0 || !menus) {
    return false;
  }

  let hasAccess = false;

  for (let i = 0; i < menus.length; i += 1) {
    const menu = menus[i];

    if (menu.menu_name === menuTitle) {
      return Boolean(menu.has_access);
    }

    if (menu.sub_menus && menu.sub_menus?.length > 0) {
      const subMenuAccess = getHasAccessAction({
        menus: menu.sub_menus,
        menuTitle,
      });
      hasAccess = subMenuAccess || hasAccess;
    }
  }

  return hasAccess;
}
